import Application from '../Application';
import ComputerSetup from './Computer';
import MonitorScreen from './MonitorScreen';
import Environment from './Environment';
import GamerChair from './GamerChair';
import RoomDecor from './RoomDecor';
import RoomLights from './RoomLights';
import Decor from './Decor';
import CoffeeSteam from './CoffeeSteam';
import AudioManager from '../Audio/AudioManager';
import WatercoolingTower from './WatercoolingTower';
import GamerSetup from './GamerSetup';
import DeskSet from './DeskSet';
import BrunoDesk from './BrunoDesk';
import { fitScreenToViewport } from './ScreenConfig';
export default class World {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.environment = new Environment();
            this.decor = new Decor();
            this.computerSetup = new ComputerSetup();
            this.monitorScreen = new MonitorScreen();
            this.coffeeSteam = new CoffeeSteam();
            this.audioManager = new AudioManager();
            // Additive props (built in code, don't touch the baked room).
            this.watercoolingTower = new WatercoolingTower();
            this.gamerSetup = new GamerSetup();
            this.gamerChair = new GamerChair();
            this.roomDecor = new RoomDecor();
            this.roomLights = new RoomLights();
            // En dernier : les taches de contact ont besoin que RoomDecor et
            // RoomLights aient fini de poser leurs objets pour savoir ou les
            // placer.
            this.deskSet = new DeskSet();
            // Apres DeskSet : le poste se pose sur le plateau, qui doit donc
            // deja exister pour que sa boite soit mesurable.
            this.brunoDesk = new BrunoDesk();
            // const hb = new Hitboxes();
            // this.cursor = new Cursor();
        });
    }
    /** Re-fit the monitor screen (and its bezel) to the new window aspect. */
    resize() {
        const { width, height } = this.application.sizes;
        if (!fitScreenToViewport(width, height))
            return;
        if (this.monitorScreen)
            this.monitorScreen.resize();
        if (this.gamerSetup)
            this.gamerSetup.resize();
    }
    update() {
        if (this.monitorScreen)
            this.monitorScreen.update();
        if (this.environment)
            this.environment.update();
        if (this.coffeeSteam)
            this.coffeeSteam.update();
        if (this.audioManager)
            this.audioManager.update();
        if (this.watercoolingTower)
            this.watercoolingTower.update();
        if (this.gamerSetup)
            this.gamerSetup.update();
        if (this.roomLights)
            this.roomLights.update();
    }
}
